import { ReactNode } from 'react';
import BaseCard from '@/components/ui/BaseCard';
import { Search, KeyboardArrowDown, CleaningServicesOutlined } from '@mui/icons-material';
import BaseButton from '@/components/ui/BaseButton';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import '@/styles/components/store/StoreFilterBlock.scss';
import { useTranslation } from 'react-i18next';

interface StoreFilterBlockProps {
    children: ReactNode; // This will include all text fields and job status checkboxes
    handleSearch: () => void;
    handleClear: () => void;
}
function StoreFilterBlock({ children, handleSearch, handleClear }: StoreFilterBlockProps) {
    const { t } = useTranslation('common');
    return (
        <BaseCard sx={{ mb: 1, pb: 0 }}>
            <Accordion>
                <AccordionSummary expandIcon={<KeyboardArrowDown />} aria-controls="filter-bar" sx={{ height: '5rem' }}>
                    <div className="accordion-header">
                        <Search />
                        <h4>{t('Filter')}</h4>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="filter-box">
                        <div className="filter-fields">{children}</div>

                        <div className="filter-buttons">
                            <BaseButton
                                variant="contained"
                                className="search-button"
                                startIcon={<Search />}
                                onClick={handleSearch}
                            >
                                {t('Search')}
                            </BaseButton>
                            <BaseButton
                                variant="outlined"
                                color="secondary"
                                className="clear-button"
                                startIcon={<CleaningServicesOutlined />}
                                onClick={handleClear}
                            >
                                {t('Clear')}
                            </BaseButton>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </BaseCard>
    );
}

export default StoreFilterBlock;
